import Script from "next/script";

export function RewardfulScripts() {
	return (
		<>
			<Script src="https://r.wdfl.co/rw.js" data-rewardful="596477"></Script>
			<Script id="rewardful-queue" strategy="beforeInteractive">
				{`(function(w,r){w._rwq=r;w[r]=w[r]||function(){(w[r].q=w[r].q||[]).push(arguments)}})(window,'rewardful');`}
			</Script>
		</>
	);
}
